// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"67dc0972","703":"e129ddd6","787":"42c912f4"}[chunkId] + ".chunk.js";
};